module.exports = __webpack_public_path__ + "img/1332626947.6b311fe2.jpg";